import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"
import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"

/**
 * Get details about AllSky timelapse videos matching the provided filters
 *
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getTimelapses = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  // Add the relevant filters
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(
    `${API_BASE_URL}/api/timelapses?${params.toString()}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get a description of a timelapse by Id
 * @param id
 * @returns {Promise<any>}
 */
export const getTimelapseById = async (id) => {
  let resp = await fetch(`${API_BASE_URL}/api/timelapses/${id}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/** timelapseMediaSrc produces the URI to use as the `src` attribute to render a given
 * timelapse. */
export const timelapseMediaSrc = (timelapseId, authToken) =>
  timelapseId
    ? `${API_BASE_URL}/api/timelapses/${timelapseId}/video${
        authToken ? "?token=" + encodeURIComponent(authToken) : ""
      }`
    : undefined
